import { MaxedDialerWidgetConfigI } from "./interface";

/**
 * True when two contact card configs ask for the same view, so a trigger
 * with the second one has nothing to change (GLE-8457)
 */
export const isSameMaxedDialerConfig = (
  a?: MaxedDialerWidgetConfigI,
  b?: MaxedDialerWidgetConfigI
): boolean => {
  const keys = new Set([
    ...Object.keys(a ?? {}),
    ...Object.keys(b ?? {}),
  ]) as Set<keyof MaxedDialerWidgetConfigI>;

  return Array.from(keys).every((key) => a?.[key] === b?.[key]);
};

/**
 * React key of the contact card. A trigger for another lead swaps the card
 * in one render, and the new key gives the new lead fresh card state, as a
 * close and reopen did.
 */
export const getMaxedDialerKey = (config?: MaxedDialerWidgetConfigI) =>
  [
    config?.campaignId,
    config?.accountId,
    config?.contactId,
    config?.phone,
    config?.email,
    config?.tab,
  ].join("|");

/**
 * True when the config asks the card to act on mount: dial a phone, open the
 * email composer, or show a tab. On `dev` each trigger closed and reopened
 * the card, so a repeat of such a trigger ran the action again (GLE-8457).
 */
export const hasMaxedDialerStartAction = (
  config?: MaxedDialerWidgetConfigI
): boolean => !!(config?.phone || config?.email || config?.tab);
